import * as React from 'react'

type Props = {
  key: string
  open?: boolean
}

type ModalState = {
  isOpen: boolean
  show: () => void
  hide: () => void
}

export const useModal = (props: Props): ModalState => {
  const [isOpen, setIsOpen] = React.useState(props?.open ?? false)

  const show = React.useCallback(() => {
    return setIsOpen(true)
  }, [props.key])

  const hide = React.useCallback(() => {
    return setIsOpen(false)
  }, [props.key])

  return {
    isOpen,
    show,
    hide,
  }
}
